import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    title: '',
    description: '',
    coverImage: '',
    level: 'beginner',
    durationMinutes: null,
    equipment: '',
    targetMuscles: '',
    isPaywall: false,
    price: null,
    currency: 'USD',
    exercises: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {},
  containerDesign: {},
};

export const workoutSlice = createSlice({
  name: 'workout',
  initialState,
  reducers: {
    workoutStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;
      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { containerDesign } = blockDesign ?? {};

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        title: blockContent?.title ?? '',
        description: blockContent?.description ?? '',
        coverImage: blockContent?.coverImage ?? '',
        level: blockContent?.level ?? 'beginner',
        durationMinutes: blockContent?.durationMinutes ?? null,
        equipment: blockContent?.equipment ?? '',
        targetMuscles: blockContent?.targetMuscles ?? '',
        isPaywall: blockContent?.isPaywall ?? false,
        price: blockContent?.price ?? null,
        currency: blockContent?.currency ?? 'USD',
        exercises: blockContent?.exercises ?? [],
        heading: {
          title: blockContent?.heading?.title ?? '',
          description: blockContent?.heading?.description ?? '',
          textAlign: blockContent?.heading?.textAlign ?? 'left',
          image: blockContent?.heading?.image ?? '',
          divider: blockContent?.heading?.divider ?? '',
          position: blockContent?.heading?.position ?? '',
        },
      };
    },
    workoutClear: () => initialState,

    workoutUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    workoutUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    workoutUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
  },
});

export const { workoutStore, workoutClear, workoutUpdateIsLoading, workoutUpdateIsActive, workoutUpdateBlockContent } = workoutSlice.actions;

export const selectWorkoutIsLoading = (state) => state.workout.isLoading;
export const selectWorkoutId = (state) => state.workout.id;
export const selectWorkoutUID = (state) => state.workout.uid;
export const selectWorkoutBlockContent = (state) => state.workout.blockContent;

export default workoutSlice.reducer;
